export default "__VITE_ASSET__2724fe62__"